// extracted by mini-css-extract-plugin
export default {"downloading_screen":"downloading_downloading_screen__GIhlF"};